/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DisconnectedUsageStateEnum = 'CREATED' | 'ACTIVATED' | 'EXPIRED';

export const DisconnectedUsageStateEnum = {

    CREATED: 'CREATED' as DisconnectedUsageStateEnum,

    ACTIVATED: 'ACTIVATED' as DisconnectedUsageStateEnum,

    EXPIRED: 'EXPIRED' as DisconnectedUsageStateEnum
};

